import { brand } from 'branding';

// export const { primarySuperLight } = brand;
export const { primarySemiSuperLight } = brand;
// export const { primaryLight } = brand;
// export const { primaryDark } = brand;

export const { accent } = brand;
export const { primaryActive } = brand;
export const { primaryNormal } = brand;
export const { primaryHover } = brand;
export const { primaryFocus } = brand;
export const { depositButtonColor } = brand;


export const primaryDark = "#0E1621";
export const primaryLight = "#17212B";
export const primarySuperLight = '#242F3D';

export const fontColorLight = "#E9E8E8";
export const fontColorDark = "#6C7883";

export const greenColor = 'rgb(52, 199, 89)';


/** Game block palette */
export const betInputBackground = '#0E1621';
export const gameBlockBackground = '#17212B';
export const betsTipsBackground = '#242F3D';
export const gameTextColor = '#6C7883';
// export const gameBlockBackground = primaryLight;
// export const betsTipsBackground = primarySuperLight;
// export const gameTextColor = '#6C7883';


/** Base colors */
export const defaultC = '#ffffff'; // deprecated
export const light = '#ffffff';

/** Dark colors */
export const dark100 = '#9FA3B0';
export const dark200 = '#676E7B';
export const dark300 = '#343A49';
export const dark400 = '#292E3A';
export const dark500 = '#242834';
export const dark600 = '#1C1F29';

/** Gray colors */
export const grey200 = '#676E7B';

/** Accent colors */
export const cautionNormal = '#F4C744';
export const cautionHover = '#F6CF60';
export const cautionActive = '#FAD824';

/** Alerts colors */
export const alertNormal = '#DE564D';
export const alertHover = '#E36E68';
export const alertActive = '#ED5148';

/** Success colors */

export const successNormal = '#5EC221';
export const successHover = '#71D733';
export const successActive = '#4DAE12';
export const successTurbo = greenColor;

/** New Tower colors */
export const bgBets = '#FFE9C3';
export const desertPalm = '#5E4631';
export const daisyLeaf = '#54643C';
export const lustyRed = '#B3393F';
export const forestSpirit = '#6D7429';
export const valentineRed = '#9A2338';
export const belovedSunflower = '#FFB422';
export const caramelLatte = '#8E6743';
export const newShoot = '#82A240';
export const ceylanite = '#37441A';
export const pohutukawa = '#5C1C28';
export const rioRed = '#8F2336';
export const calypsoBerry = '#C53952';
export const smokedOakBrown = '#544318';
export const hamtaroBrown = '#A97D27';